import cl from './Home.module.css'

import bankPartnerImg from '../../../assets/images/bankpartner_img.jpg'
import CardsPartner from '../../../assets/images/CardsPartner.jpg'
import smartToolImg1 from '../../../assets/images/smartToolImg1.jpg'
import smartToolImg2 from '../../../assets/images/smartToolImg2.jpg'
import openAccSecImg from '../../../assets/images/openAccSecImg.jpg'
import openAccThirdImg from '../../../assets/images/openAccThirdImg.jpg'

import circle from '../../../assets/images/circle.png'
import light_card from '../../../assets/images/light_card.png'
import black_card from '../../../assets/images/black_card.png'

import arrow_outward from '../../../assets/images/arrow_outward.svg'
import arrow_feauture from '../../../assets/images/arrow_feauture.svg'
import credit_score from '../../../assets/images/credit_score.svg'
import howItWork from '../../../assets/images/howItWork.svg'
import manageIcon from '../../../assets/images/manageIcon.svg'
import telegramIcon from '../../../assets/images/telegram.svg'
import whatsAppIcon from '../../../assets/images/whatsApp.svg'

import Partners from '../../../components/Partners/Partners';
import Footer from '../../../components/Footer/Footer';
import { NavLink } from 'react-router-dom';




const Home = () => {

    

    return (
        <div className='main_home_page'>
            
            <div className={cl.banking_partner_container}>
                <div className={cl.left_side_container}>
                    <h2 className={cl.title_bank_partner}>
                        Your Digital Banking Partner
                    </h2>
                    <p className={cl.descriotion_bank_partner}>
                        Boost your growth with powerful, easy-to-use payment processing tools. Fortres BanCorp unifies online, point of sale, and B2B payments into a single platform. Perfect for businesses ready to scale.
                    </p>
                    <div className={cl.row_bank_partners_btn}>
                        <div className={cl.btn_open}>
                            <NavLink to='/sign-up'>
                                Open Account
                            </NavLink>
                        </div>
                        <div className={cl.btn_how_work}>
                            <NavLink to='/contact-us#contact-form' style={{display: 'flex'}}>
                                <span className={cl.text_btn_work}>How it Work</span>
                                <img src={howItWork} alt="#how_it_work_img" />
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div className={cl.right_side_container}>
                    <img src={circle} alt="#back_image_circle" className={cl.background_circle} />
                    <img src={light_card} alt="#light_card_image" className={cl.light_card} />
                    <img src={black_card} alt="#black_card_image" className={cl.black_card} />
                    {/* <img src={bankPartnerImg} alt="#bankPartnerImg" /> */}
                </div>
            </div>
            <Partners />
            <div className={cl.empower_money_block}>
                <div className={cl.left_side_container}>
                    <h2 className={cl.title_container}>
                        Empower Your Money,
                        <span className={cl.second_part_title}>Choose Our Bank</span>
                    </h2>
                </div>
                <div className={cl.empower_right_side_container}>
                    <p className={cl.empower_money_text}>
                        Fortres BanCorp invites you to harness financial strength with our institution. Through innovative services and steadfast security, we empower your financial journey. Our commitment ensures your money grows confidently, supported by reliable expertise and personalized solutions. Choose us for a banking experience that prioritizes your prosperity.
                    </p>
                        <NavLink to='/contact-us#contact-form'>
                    <div className={cl.btn_money_wrapper}>
                        <span className={cl.btn_money_text}>Discover More</span>
                        <img src={howItWork} alt="#btn_row" />
                    </div>
                        </NavLink>
                </div>
            </div>
            <div className={cl.services_page}>
                <h2 className={cl.services_title}>
                    Services
                </h2>
                <h3 className={cl.services_subtitle}>
                    Smart Tools for Smart Banking
                </h3>
                <div className={cl.services_block_container}>
                   <div className={cl.upper_block}>
                        <div className={cl.first_img_item_container}>
                            <img src={smartToolImg1} alt="#smart_Tool_Img1" />
                        </div>
                        <div className={cl.second_services_content_block}>
                            <div className={cl.img_block_container}>
                                <img src={manageIcon} alt="#manage_icon" />
                            </div>
                            <h3 className={cl.title_services_block}>
                                Manage personal cash flow
                            </h3>
                            <p className={cl.services_description_block}>
                                With our intuitive tools and resources, you can easily track your income, expenses, and savings to make informed decisions and ensure you stay on top of your finances.
                            </p>
                                <NavLink to='/contact-us#contact-form'>
                            <div className={cl.btn_services_wrapper}>
                                <span className={cl.text_block}>Know More</span>
                                <img src={howItWork} alt="#services_button_image" />
                            </div>
                                </NavLink>
                        </div>
                   </div>
                   <div className={cl.bottom_block}>
                    <div className={cl.third_services_content_block}>
                        <div className={cl.img_block_container}>
                            <img src={credit_score} alt="#manage_icon" />
                        </div>
                        <h3 className={cl.title_services_block}>
                            Transparent payment solutions
                        </h3>
                        <p className={cl.services_description_block}>
                          We believe in giving you full visibility and control over your financial transactions, ensuring you always know where your money is going and that you’re never hit with hidden fees or unclear terms.
                        </p>
                            <NavLink to='/contact-us#contact-form'>
                        <div className={cl.btn_services_wrapper}>
                            <span className={cl.text_block}>Know More</span>
                            <img src={howItWork} alt="#services_button_image" />
                        </div>
                            </NavLink>
                    </div>
                     <div className={cl.four_img_item_container}>
                        <img src={smartToolImg2} alt="#smart_Tool_Img1" />
                    </div>
                   </div>
                     
                </div>
            </div>
            <div className={cl.our_feautures}>
                <h2 className={cl.title_feautures}>
                    Our Features
                </h2>
                <div className={cl.our_feautures_row}>
                    <div className={cl.our_feautures_block_item}>
                        <h3 className={cl.feautures_title_item}>
                            Investment
                        </h3>
                        <div className={cl.feautures_img_wrapper}>
                            <img src={arrow_feauture} alt="#arrow" />
                        </div>
                        <p className={cl.feautures_description_text}>
                            Strategically grow your wealth with personalized financial plans and expert guidance.
                        </p>
                    </div>
                     <div className={[cl.our_feautures_block_item, cl.our_feautures_second].join(' ')}>
                        <h3 className={cl.feautures_title_item_second}>
                            Security
                        </h3>
                        <div className={cl.feautures_img_wrapper}>
                            <img src={arrow_feauture} alt="#arrow" />
                        </div>
                        <p className={[cl.feautures_description_text, cl.feauture_descr_second].join(' ')}>
                           Rest easy knowing your payments are processed safely with the highest security standards, ensuring predictable and reliable transactions for everyone.
                        </p>
                    </div>
                     <div className={cl.our_feautures_block_item}>
                        <h3 className={cl.feautures_title_item}>
                            Cashback
                        </h3>
                        <div className={cl.feautures_img_wrapper}>
                            <img src={arrow_feauture} alt="#arrow" />
                        </div>
                        <p className={cl.feautures_description_text}>
                           Enjoy rewards and savings with cashback offers on purchases made through our platform.
                        </p>
                    </div>
                </div>
            </div>
            <div className={cl.open_account_wrapper}>
                <div className={cl.first_block_account}>
                    <h3 className={cl.open_account_title}>
                        Open your account
                    </h3>
                    <span className={cl.open_account_subtitle}>
                        It only takes a few minutes!
                    </span>
                    <div className={cl.open_account_buttons_wrapper}>
                        <NavLink to='/sign-up'>
                        <div className={cl.open_account_btn}>
                            Open Account
                        </div>
                        </NavLink>
                        <NavLink to='/contact-us#contact-form'>
                        <div className={cl.talk_btn}>
                            <span className={cl.talk_btn_text}>
                                Talk to Us
                            </span>
                            <img src={arrow_outward} alt="#talk_to_us" />
                        </div>
                        </NavLink>
                    </div>
                </div>
                <div className={cl.second_block_wrapper}>
                    <img src={openAccSecImg} alt="#profile_img" />
                </div>
                <div className={cl.third_block_wrapper}>
                    <img src={openAccThirdImg} alt="" />
                </div>
            </div>
            <div className={cl.support_container}>
                <h4 className={cl.support_title}>
                    Contact Us
                </h4>
                <h3 className={cl.support_subtitle}>
                    Your Support, Our Priority
                </h3>
                <div className={cl.support_container_info}>
                    <div className={cl.support_info_block}>
                        <h4 className={cl.support_title_block}>
                            Email :
                        </h4>
                        <span className={cl.support_text_block}>info@fortres.tech</span>
                         
                    </div>
                     <div className={cl.support_info_block}>
                        <h4 className={cl.support_title_block}>
                            Phone :
                        </h4>
                        <span className={cl.support_text_block}>+420775497164</span>
                        {/* <span className={cl.support_text_block}></span> */}
                    </div>
                    <div className={cl.support_info_block}>
                        <h4 className={cl.support_title_block}>
                            Social links :
                        </h4>
                        <div className={cl.links_row}>
                            <div className="img_telegram">
                                <a href="https://t.me/+420775497164" target="_blank">
                                <img src={telegramIcon} alt="#telegramIcon"/>
                                </a>
                            </div>
                            <div className="img_telegram">
                                <a href="https://wa.me/420775497164" target="_blank">
                                <img src={whatsAppIcon} alt="#whatsAppIcon"/>
                                </a>
                            </div>
                        </div>
                        {/* <span className={cl.support_text_block}></span> */}
                    </div>
                     <div className={cl.support_info_block}>
                        <h4 className={cl.support_title_block}>
                            Address :
                        </h4>
                        <span className={cl.support_text_block}>Olštýnská 607/1, Troja (Praha 8), 181 00 Praha</span>
                        <span className={cl.support_text_block}>P.O. Box 149, PC 325, Sultanate of Oman</span>
                    </div>
                     <div className={cl.support_info_block}>
                        <h4 className={cl.support_title_block}>
                            Bank Hours :
                        </h4>
                        <span className={cl.support_text_block}>Monday - Friday: 9:00 AM - 6:00 PM (EST)</span>
                        <span className={cl.support_text_block}>Saturday: 10:00 AM - 4:00 PM (EST)</span>
                        <span className={cl.support_text_block}>Sunday: Closed</span>
                    </div>
                    
                </div>
                <div className={cl.btn_contact_now}>
                    <NavLink to='/contact-us#contact-form' className={cl.a_link}>
                        <span className={cl.btn_contact_text}>Contact Now</span>
                </NavLink>
                </div>
            </div>
            
        </div>
    );
};

export default Home;